// Explicit synthetic preview data. Never used as component defaults.
import { ART_BASE } from '../assets.js';
const ASSET = ART_BASE;

export const FIXTURE_KIDS = [
  {
    id: 'maya',
    name: 'Maya',
    avatar: `${ASSET}/avatar-kid-1.jpg`,
    litCount: 2,
    totalCount: 3,
    quests: [
      { id: 'maya-dishes', title: 'Unload the dishwasher', icon: `${ASSET}/icon-dishes.png`, status: 'done', reward: 0.75, when: 'lit at 7:31' },
      { id: 'maya-dog', title: 'Walk Biscuit', icon: `${ASSET}/icon-dog.png`, status: 'done', reward: 1.0, when: 'lit at 4:12' },
      { id: 'maya-broom', title: 'Sweep the porch', icon: `${ASSET}/icon-broom.png`, status: 'unlit', reward: 0.5, when: 'tonight' },
    ],
  },
  {
    id: 'leo',
    name: 'Leo',
    avatar: `${ASSET}/avatar-kid-2.jpg`,
    litCount: 2,
    totalCount: 3,
    quests: [
      { id: 'leo-hw', title: 'Finish math homework', icon: `${ASSET}/icon-homework.png`, status: 'done', xp: 20, when: 'lit at 6:55' },
      { id: 'leo-trash', title: 'Take out the trash', icon: `${ASSET}/icon-trash.png`, status: 'pending', reward: 0.75, when: 'high-five on its way' },
      { id: 'leo-laundry', title: 'Fold the laundry', icon: `${ASSET}/icon-laundry.png`, status: 'unlit', reward: 1.25, streak: 'streak quest' },
    ],
  },
  {
    id: 'finn',
    name: 'Finn',
    avatar: `${ASSET}/avatar-kid-3.jpg`,
    litCount: 1,
    totalCount: 2,
    quests: [
      { id: 'finn-bed', title: 'Make your bed', icon: `${ASSET}/icon-bed.png`, status: 'done', reward: 0.5, when: 'lit at 5:20' },
      { id: 'finn-plant', title: 'Water the plants', icon: `${ASSET}/icon-plant.png`, status: 'unlit', reward: 0.5, when: 'before bed' },
    ],
  },
];

export const FIXTURE_ACTORS = [
  { id: 'maya', name: 'Maya', avatarUrl: `${ASSET}/avatar-kid-1.jpg`, requiresPin: true },
  { id: 'leo', name: 'Leo', avatarUrl: `${ASSET}/avatar-kid-2.jpg`, requiresPin: true },
  { id: 'finn', name: 'Finn', avatarUrl: `${ASSET}/avatar-kid-3.jpg`, requiresPin: true },
  { id: 'sara', name: 'Sara', avatarUrl: `${ASSET}/avatar-parent-1.jpg`, locked: true },
  { id: 'david', name: 'David', avatarUrl: `${ASSET}/avatar-parent-2.jpg`, locked: true },
];

export const FIXTURE_PRESENCE = [
  { id: 'maya', name: 'Maya', time: '7:31', x: 30, y: 46 },
  { id: 'leo', name: 'Leo', time: '6:55', x: 62, y: 38 },
  { id: 'finn', name: 'Finn', time: '5:20', x: 81, y: 55 },
];

export const FIXTURE_PAYDAY = {
  when: 'Friday · 2 days',
  sub: 'Chapter 24 of the Silva story · light 9 more lanterns before the festival',
  value: 21,
  goal: 30,
  unit: 'family lanterns this week',
  image: `${ASSET}/payday-festival.jpg`,
};

export const FIXTURE_CAPTION = {
  title: 'The village is glowing ✦',
  detail: '5 lanterns lit tonight — 2 more and the square lights up.',
};

export const displayFixture = {
  kids: FIXTURE_KIDS,
  actors: FIXTURE_ACTORS,
  presence: FIXTURE_PRESENCE,
  payday: FIXTURE_PAYDAY,
  caption: FIXTURE_CAPTION,
  familyName: 'The Silva Village',
};
